import clsx from 'clsx';
import { getTailwindColor } from '@/utils/colors';
import { Level, Margin, Size, HeaderSize, getHeaderFontSize, getMargin } from '@/utils/typography';
import { extractLangFromSpan } from '@/utils/lang-span';
import { PropsWithChildren } from 'react';

export type HeadlineProps = PropsWithChildren<{
    level: Level; // This is the same as tag
    tag: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
    color: string;
    margin: Margin;
    marginSize: Size;
    size: HeaderSize;
    align: null | 'left' | 'center' | 'right';
    font: 'default' | 'secondary';
    fontWeight?: 'bold' | 'medium';
    index: number;
    hash: string;
}>;

export const Headline = ({ children, tag: Tag, ...props }: HeadlineProps) => {
    const classNames = clsx(
        getTailwindColor(props.color, 'text'),
        getMargin(props.margin, props.marginSize),
        getHeaderFontSize(props.level, props.size),
        'r-overflow-hidden md:r-overflow-visible styled-link',
        {
            'r-font-serif': props.font === 'secondary',
            'r-text-center': props.align === 'center',
            'r-text-right': props.align === 'right',
            'r-font-bold': props.level !== 6 && props.fontWeight === 'bold',
            'r-font-medium': props.level !== 6 && props.fontWeight !== 'bold',
        }
    );

    if (!children) {
        return null;
    }

    const htmlString = typeof children === 'string' ? children : String(children);
    const { lang, content } = extractLangFromSpan(htmlString);

    return <Tag className={classNames} lang={lang ?? undefined} dangerouslySetInnerHTML={{ __html: content }} />;
};
